import React, { useState, useEffect } from 'react'
import Sidebar from './Sidebar'
import Navbar from "./Navbar"
import { Outlet, useNavigate, useLocation } from 'react-router-dom'
import { jwtDecode } from "jwt-decode"
import "./Layout.scss"
import BtnDroxyAI from './BtnDroxyAI'

function Layout() {
    const [sidebarOpen, setSidebarOpen] = useState(() => {
        const saved = localStorage.getItem("sidebar-collapsed")
        return saved ? JSON.parse(saved) : false
    })

    const navigate = useNavigate()
    const location = useLocation()

    const handleBack = () => {
        navigate(-1)
    }

    const token = localStorage.getItem("token")
    let user;
    user = jwtDecode(token)?.apirest?.objeto
    const puesto = Number(user.puesto)
    const homePath = (puesto === 6 || puesto === 7) ? '/normas' : '/home'

    const hiddenPaths = [homePath]
    const showBackButton = !hiddenPaths.includes(location.pathname)

    useEffect(() => {
        localStorage.setItem("sidebar-collapsed", JSON.stringify(sidebarOpen))
    }, [sidebarOpen])

    return (
        <div className={sidebarOpen ? "sidebarOpen active" : "sidebarOpen"}>
            <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen}/>
            <div className="main">
                <Navbar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen}/>
                <div className='main__outlet__container bg-white'>
                    {showBackButton && <button className='btn__locationBack btn p-0 mb-3 border-0' onClick={handleBack}><i className="bi bi-chevron-left"></i> <span>atrás</span></button>}
                    <Outlet />
                </div>
            </div>
            <BtnDroxyAI />
        </div>
    )
}

export default Layout